import {
    SHARE_ON_EMAIL,
    SHARE_ON_FACEBOOK,
    SHARE_ON_FACEBOOK_MESSENGER,
    SHARE_ON_LINKEDIN,
    SHARE_ON_TWITTER,
    SHARE_ON_WHATSAPP,
} from '@eb/eds-share-box';
import React from 'react';
import { AppProps } from '../../types';
import { TrackedShareEvent } from '../ShareEvent/TrackedShareEvent';
import ShareEventModal, {
    ShareEventModalProps,
} from '../ShareEventModal/ShareEventModal';
import { dynaMount } from '../utils/mountComponent';

const LISTING_UTM_OPTIONS = {
    'utm-campaign': 'social',
    'utm-content': 'attendeeshare',
    'utm-medium': 'discovery',
    'utm-term': 'listing',
};

const DESKTOP_SHARE_TYPES = [
    SHARE_ON_FACEBOOK,
    SHARE_ON_FACEBOOK_MESSENGER,
    SHARE_ON_LINKEDIN,
    SHARE_ON_TWITTER,
    SHARE_ON_EMAIL,
];

const MOBILE_SHARE_TYPES = [
    SHARE_ON_FACEBOOK,
    SHARE_ON_LINKEDIN,
    SHARE_ON_TWITTER,
    SHARE_ON_EMAIL,
    SHARE_ON_WHATSAPP,
];

const getShareEventProps = (props: any): ShareEventModalProps => {
    const {
        event: { name: eventName, id: eventId, url: eventUrl },
        components: { shareEvent },
        settings: { baseUrl: serverUrl, isMobile },
    } = props;

    return {
        ...shareEvent,
        eventName,
        eventId: `${eventId}`,
        eventUrl,
        serverUrl,
        isMobile,
        shareTypes: isMobile ? MOBILE_SHARE_TYPES : DESKTOP_SHARE_TYPES,
        utmOptions: LISTING_UTM_OPTIONS,
    };
};

const ShareEventInline = (props: ShareEventModalProps) => (
    <div className="eds-l-mar-top-2 eds-text--left">
        <TrackedShareEvent {...props} />
    </div>
);

const TrackedShareEventRootMount = (props: ShareEventModalProps) =>
    dynaMount(
        {
            Component: ShareEventInline,
            containerId: 'listings-root__share-event',
        },
        props,
    );

const ShareEventModalRootMount = (props: ShareEventModalProps) =>
    dynaMount(
        {
            Component: ShareEventModal,
            containerId: 'listings-root__share-event-modal',
        },
        props,
    );

const ShareEventRoot = (props: AppProps) => {
    const shareEventProps = getShareEventProps(props);

    return (
        <>
            <TrackedShareEventRootMount {...shareEventProps} />
            <ShareEventModalRootMount {...shareEventProps} />
        </>
    );
};

export default ShareEventRoot;
